export default __webpack_public_path__ + "static/media/busimob-3.db6c2c97.svg";